import { Enum } from '../../common/constants'

export const MobileAppSchemes = {
  Production: 'synkedup',
  Development: 'synkedup.dev',
  Staging: 'synkedup.staging'
} as const
export type MobileAppScheme = Enum<typeof MobileAppSchemes>

const DEFAULT_MOBILE_APP_URL = `${MobileAppSchemes.Production}://`
const COMPLETED_HANDOFFS_KEY = 'synkedup_completed_handoffs'
const MAX_REMEMBERED_HANDOFFS = 20
const HANDOFF_KEY_LENGTH = 8

export const isMobileAppScheme = (value: string): value is MobileAppScheme =>
  Object.values(MobileAppSchemes).some(scheme => scheme === value)

const appUrl = (base: string, path: string, params: Record<string, string>): string => {
  const query = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')
  if (query === '') {
    return `${base}${path}`
  }
  return `${base}${path}?${query}`
}

export const mobileAppUrl = (path: string, params: Record<string, string>): string =>
  appUrl((window as any).env?.MOBILE_APP_URL ?? DEFAULT_MOBILE_APP_URL, path, params)

export const mobileAppUrlForScheme = (scheme: MobileAppScheme, path: string, params: Record<string, string>): string =>
  appUrl(`${scheme}://`, path, params)

const handoffKey = (token: string): string => token.slice(0, HANDOFF_KEY_LENGTH)

const readCompletedHandoffs = (): string[] => {
  try {
    const stored = localStorage.getItem(COMPLETED_HANDOFFS_KEY)
    if (!stored) {
      return []
    }
    const parsed = JSON.parse(stored)
    if (!Array.isArray(parsed)) {
      return []
    }
    return parsed.filter(entry => typeof entry === 'string')
  } catch {
    return []
  }
}

export const hasCompletedHandoff = (token: string): boolean => {
  if (!token) {
    return false
  }
  return readCompletedHandoffs().includes(handoffKey(token))
}

export const recordCompletedHandoff = (token: string): void => {
  if (!token) {
    return
  }
  const key = handoffKey(token)
  const others = readCompletedHandoffs().filter(entry => entry !== key)
  try {
    localStorage.setItem(
      COMPLETED_HANDOFFS_KEY,
      JSON.stringify([key, ...others].slice(0, MAX_REMEMBERED_HANDOFFS))
    )
  } catch {
    return
  }
}
